<template>
  <div ref="selectCountry" class="select-country-component flex flex-col justify-items-center relative mr-[20px]">
    <div :class="['select-country-base',
      'w-[230px]',
      'h-[34px]',
      'flex',
      'flex-row',
      'justify-items-center',
      'bg-white',
      'border',
      'border-light-gray',
      'p-1',
      'text-base', {
      'show-auto-complete': showAutocomplete,
      'justify-start pl-2.5': !hasSelectedCountry,
      'justify-center': hasSelectedCountry
    }]">

      <!-- Country flag -->
      <div v-show="hasSelectedCountry" class="flag-icon relative mx-[5px] mt-[4px]">
        <country-flag :country="model.countryCode" size='normal' class="plan-upgrade-flag selected-country"/>
      </div>

      <!-- Country name -->
      <div :class="['selected-country w-[160px] pr-[20px] pt-[4px] text-xs text-[#9FA0AD]', {
        'text-[#9FA0AD]': hasSelectedCountry
        }]">{{countryName}}</div>

      <!-- Dropdown arrow -->
      <div @click="handleArrowClick()"
        :class="['arrow','w-[15px] h-full top-0 absolute right-[9px]',
          { top: showAutocomplete }]">
        <el-icon class="w-full! h-full! text-[#9FA0AD]!"><ArrowDown /></el-icon>
      </div>

      <div @click="handleArrowClick()" :title="countryName"
      class="cover
        absolute
        left-0
        top-0
        w-full
        h-full
        z-10
        cursor-pointer">
      </div>
    </div>

    <div v-show="showAutocomplete"
      ref="countryAutoCompleteWrapper"
      class="absolute
        text-center
        left-0
        right-0
        border
        border-[#DCDFE5]
        bg-white
        pt-[12px]
        pb-[12px]
        z-10">
        <el-select ref="countryAutoCompleteSelectbox"
          class="country-selectbox text-xs"
          v-model="model.countryCode"
          filterable
          placement="bottom-start"
          :placeholder="$t('label.search')"
          :automatic-dropdown="true"
          :teleported="false"
          :popper-class="'select-country-component-popper'"
          @change="handleDropdownChange">

          <template #prefix>
            <div class="pl-2">
              <font-awesome-icon icon="fa-solid fa-search" class="w-[12px] h-full text-[#9FA0AD] text-xs"/>
            </div>
          </template>

          <el-option v-for="(item, indx) in countries"
            :key="indx"
            :value-key="item.code"
            :label="item.name"
            :value="item.code">
            <country-flag :country="item.code" :title="item.name" size='normal' class="plan-upgrade-flag options"/>
            <label class="plan-upgrade-country-name" :title="item.name">{{item.name}}</label>
          </el-option>
      </el-select>
    </div>
  </div>
</template>

<script src="./select-country.js"></script>
<style lang="scss" src="./select-country.scss"></style>
